import { AnswerType, QuestionType } from "app/types";

const cloneAnswers = (answers: AnswerType[] = []): AnswerType[] =>
  answers.map(answer => ({
    ...answer,
    fragrances: answer.fragrances ? [...answer.fragrances] : undefined,
    answer: answer.answer
      ? {
          ...answer.answer,
          files: answer.answer.files
            ? answer.answer.files.map(file => ({ ...file }))
            : undefined,
        }
      : undefined,
  }));

export const getQuestionPackageSourceId = (question: QuestionType): number =>
  question.cloneSourceQuizQuestionId ?? question.quizQuestionId;

const movePackageToSlot = (
  destination: QuestionType,
  source: QuestionType,
): QuestionType => {
  const destinationLabel =
    destination.question?.quest || destination.quest || "";

  return {
    ...source,
    // Estes campos identificam o slot e não fazem parte do pacote movido.
    quizId: destination.quizId,
    quizQuestionId: destination.quizQuestionId,
    questionId: destination.questionId,
    arrangeQuestionSequence: destination.arrangeQuestionSequence,
    quest: destinationLabel,
    question: {
      ...(source.question || { description: source.description || "" }),
      quest: destinationLabel,
    },
    answers: cloneAnswers(source.answers),
    files: source.files?.map(file => ({ ...file })),
    file: source.file ? { ...source.file } : undefined,
    cloneSourceQuizQuestionId: getQuestionPackageSourceId(source),
  };
};

/**
 * Rotaciona os pacotes completos entre os slots selecionados. A label e a
 * sequência de cada slot permanecem no lugar.
 */
export const rotateQuestionPackages = (
  questions: QuestionType[],
  selectedQuestionIds: number[],
): QuestionType[] => {
  if (selectedQuestionIds.length < 2) {
    return questions;
  }

  const selectedSet = new Set(selectedQuestionIds);
  const selectedSlots = questions.filter(question =>
    selectedSet.has(question.quizQuestionId),
  );

  if (selectedSlots.length < 2) {
    return questions;
  }

  const sourceByDestinationId = new Map<number, QuestionType>();

  selectedSlots.forEach((destination, index) => {
    const source = selectedSlots[(index + 1) % selectedSlots.length];
    sourceByDestinationId.set(destination.quizQuestionId, source);
  });

  return questions.map(destination => {
    const source = sourceByDestinationId.get(destination.quizQuestionId);
    return source ? movePackageToSlot(destination, source) : destination;
  });
};

export const getQuestionLabel = (question: QuestionType): string =>
  question.question?.quest || question.quest || "-";
